import React, { useEffect, useRef, useState } from 'react'
import {
  GridIcon,
  SettingsIcon,
  UniversityIcon,
  CoursesIcon,
  SpecializationIcon,
  InquiresIcon,
  StudentSectionIcon,
  PlacementIcon,
  ActivityLogsIcon,
} from '../icons'
import { Tooltip } from '@mui/material'
import RateReviewIcon from '@mui/icons-material/RateReview'
import { useSelector } from 'react-redux'
import { hasModuleAccess } from '../utils/helperFunction'


const AppSidebar = () => {
  const sidebarRef = useRef(null)
  const [isActive, setIsActive] = useState(false)
  const userAuth = useSelector(state => state?.auth)

  const sidebarMenu = [
    { label: 'Admin', isTitle: true },
    ...(hasModuleAccess(userAuth?.user?.roles, ["admin"]) ? [{ label: 'Dashboard', icon: <GridIcon className="nav-icon" />, href: '/' },
    { label: 'University', icon: <UniversityIcon className="nav-icon" />, href: '/university-listing-management' },
    { label: 'Courses', icon: <CoursesIcon className="nav-icon" />, href: '/course-listing-management' },
    { label: 'Specialization', icon: <SpecializationIcon className="nav-icon" />, href: '/specialization-listing-management' },] : []),
    ...(hasModuleAccess(userAuth?.user?.roles, ["student"]) ? [{ label: 'Student Section', icon: <StudentSectionIcon className="nav-icon" />, href: '/user/university-review' }] : []),
    ...(hasModuleAccess(userAuth?.user?.roles, ["reviewer"]) ? [{ label: 'Review', icon: <RateReviewIcon className="nav-icon" />, href: '/review' }] : []),
    ...(hasModuleAccess(userAuth?.user?.roles, ["web"]) ? [{
      label: "Website", icon: <GridIcon className="nav-icon" />, submenu: [
        ...(hasModuleAccess(userAuth?.user?.roles, ["web.leads"], false) ? [{ label: 'Leads', icon: <UniversityIcon className="nav-icon" />, href: '/leads' }] : []),
        ...(hasModuleAccess(userAuth?.user?.roles, ["web.reviews_rating"]) ? [{ label: 'Reviews & Ratings', icon: <UniversityIcon className="nav-icon" />, href: '/universtiy-rating' }] : []),
        ...(hasModuleAccess(userAuth?.user?.roles, ["web.admission"]) ? [{ label: 'Admission', icon: <UniversityIcon className="nav-icon" />, href: '/admission' }] : []),
        ...(hasModuleAccess(userAuth?.user?.roles, ["web.payment_requests"]) ? [{ label: 'Payment Requests', icon: <UniversityIcon className="nav-icon" />, href: '/payment-requests' }] : []),
        ...(hasModuleAccess(userAuth?.user?.roles, ["web.regerral_management"]) ? [{ label: 'Referral Management', icon: <UniversityIcon className="nav-icon" />, href: '/ReferralManagement' }] : []),

      ]
    }] : []),
  ]

  // Check if .sidebar has 'active' class
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const isSidebarActive = sidebarRef.current?.classList.contains('active')
      setIsActive(isSidebarActive)
    })

    if (sidebarRef.current) {
      observer.observe(sidebarRef.current, { attributes: true, attributeFilter: ['class'] })
    }

    return () => observer.disconnect()
  }, [])

  return (
    <aside ref={sidebarRef} className="sidebar">
      <button type="button" className="sidebar-close-btn">
        <span className="icon">×</span>
      </button>

      <div>
        <a href="/" className="sidebar-logo">
          <img src="/assets/images/logo/logo.svg" alt="site logo" className="light-logo" />
          <img src="/assets/images/logo/logo.svg" alt="site logo" className="dark-logo" />
          <img src="/assets/images/logo/logo-icon.svg" alt="site logo" className="logo-icon" width={30} height={30} />
        </a>
      </div>

      <div className="sidebar-menu-area">
        <ul className="sidebar-menu" id="sidebar-menu">
          {sidebarMenu.map((item, index) =>
            item.isTitle ? (
              <li key={index} className="sidebar-menu-group-title">
                {item.label}
              </li>
            ) : (
              <li key={index} className={item.submenu ? 'dropdown' : ''}>
                {item.submenu ? (
                  <>
                    <a className="gap-2" onClick={(e) => e.preventDefault()}>
                      {isActive ? (
                        <Tooltip title={item.label} placement="right" arrow>
                          <span className="nav-icon-wrapper">{item.icon}</span>
                        </Tooltip>
                      ) : (
                        <span className="nav-icon-wrapper">{item.icon}</span>
                      )}
                      <span>{item.label}</span>
                    </a>
                    <ul className="sidebar-submenu">
                      {item.submenu.map((subItem, subIndex) => (
                        <li key={subIndex}>
                          <a href={subItem.href} className="gap-2" >
                            {/* <span className="nav-icon-wrapper ">{subItem.icon}</span> */}
                            <i className={`ri-circle-fill circle-icon ${subItem.iconClass} w-auto`} />
                            {subItem.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <a href={item.href} className="d-flex gap-2 align-items-center">
                    {isActive ? (
                      <Tooltip title={item.label} placement="right" arrow>
                        <span className="nav-icon-wrapper">{item.icon}</span>
                      </Tooltip>
                    ) : (
                      <span className="nav-icon-wrapper">{item.icon}</span>
                    )}
                    <span>{item.label}</span>
                  </a>
                )}
              </li>
            )
          )}
        </ul>
      </div>
    </aside>
  )
}

export default AppSidebar
